import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClientLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 150,
	height: 150,
	viewBox: "0 0 150 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M102.937 129.233C98.8083 131.282 90.4372 135.416 86.3289 137.49L82.1795 139.559C79.5248 140.886 76.5094 141.456 73.5609 141.145C71.731 140.957 69.9423 140.454 68.3032 139.646C67.7413 139.386 65.8032 138.303 65.2671 138.029C62.6949 136.641 55.6795 132.848 53.03 131.424C48.6485 129.06 34.7568 121.566 30.6073 119.299C29.999 118.968 29.3186 118.592 28.7568 118.196C25.1485 115.745 22.9063 111.673 22.6382 107.397C22.6382 107.143 22.6125 106.634 22.6125 106.38C22.6434 104.479 22.6125 100.889 22.6125 98.9267C22.5454 91.8444 22.3135 83.0387 22.03 75.9972C20.9063 51.1205 20.6434 51.7305 19.5454 75.9972C19.2413 83.054 19.0558 91.8343 18.963 98.9267C18.9733 101.443 18.8856 105.17 19.0145 107.651C19.4166 112.949 22.499 117.941 27.0197 120.768C27.6795 121.2 28.4784 121.622 29.1846 121.968C33.499 124.119 47.432 131.145 51.963 133.433C54.6485 134.785 61.8032 138.39 64.3856 139.691C65.6228 140.306 67.3856 141.257 68.664 141.72C71.7207 142.838 75.0918 143.062 78.2671 142.355C81.0918 141.837 84.3289 139.793 86.8444 138.446C90.9217 136.244 99.0403 131.77 103.112 129.548C103.195 129.503 103.226 129.401 103.185 129.32C103.138 129.233 103.035 129.198 102.947 129.243L102.937 129.233ZM130.468 8.53566C130.484 7.68152 129.777 6.98499 128.911 7.00025C109.391 7.35105 79.9423 7.81879 60.6846 8.3628C60.5918 8.3628 60.5145 8.43906 60.5145 8.53057C60.5145 8.62717 60.5867 8.70852 60.6846 8.70852L69.2155 8.92205C84.1795 9.25252 111.308 9.80669 127.319 10.0456C127.061 19.5022 126.973 28.9892 127.329 38.4457C127.612 46.1736 127.973 54.0082 128.736 61.7107C128.746 61.7921 128.808 61.8582 128.896 61.8683C128.994 61.8785 129.082 61.8073 129.092 61.7107C129.746 55.0962 130.107 48.4004 130.37 41.7707C130.875 30.7127 130.808 19.5937 130.468 8.53566Z",
			fill: "#90FF91"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 80.8682,
			width: 150,
			height: 45.7573,
			fill: "url(#pattern0_3219_41)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.109 86.3291H5.58789V120.733H144.109V86.3291Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.145 86.8775H143.552V120.179H6.14981V86.8775H121.15M121.145 85.7793H5.03125V86.8826V120.184V121.287H143.552H144.67V86.8826V85.7793H121.263H121.15H121.145Z",
			fill: "#C00E1A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.0709 96.639H22.4627V101.174H28.0812C28.0812 102.47 27.9163 104.25 27.4214 105.546H22.4627V114.937H17.5039V92.2666H29.0709V96.639Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.4242 114.942H41.3005L41.1046 113.259C40.5737 112.644 39.3521 112.029 38.3933 111.704L38.8211 108.465H40.5067L39.4139 99.7203H39.218L37.3366 114.942H32.2129L35.682 92.2721C36.2747 92.1755 38.8211 92.1094 39.4191 92.1094C39.9809 92.1094 42.5583 92.1755 43.1201 92.2721L46.4242 114.942Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.8037 103.279V92.2666H64.4326V114.937H59.8037L56.0357 103.925H55.8398V114.937H51.2109V92.2666H55.8398L59.6078 103.279H59.8037Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.4553 92.2666V96.639H77.8213V114.937H72.8625V96.639H69.2285V92.2666H81.4553Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.1442 114.942H93.0205L92.8246 113.259C92.2937 112.644 91.0721 112.029 90.1133 111.704L90.5411 108.465H92.2267L91.1339 99.7203H90.938L89.0514 114.942H83.9277L87.3968 92.2721C87.9896 92.1755 90.536 92.1094 91.1339 92.1094C91.6958 92.1094 94.2731 92.1755 94.8349 92.2721L98.1391 114.942H98.1442Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.165 99.0692C114.176 99.359 111.366 99.5573 110.207 99.5573V96.644C109.908 96.4813 109.48 96.3186 108.882 96.3186C108.284 96.3186 107.856 96.4813 107.562 96.644V97.6151C107.562 99.0743 107.892 99.4301 108.882 100.208L112.846 103.284C114.562 104.611 115.16 106.04 115.16 107.819V110.087C115.16 113.518 112.382 115.267 108.882 115.267C105.382 115.267 102.604 113.518 102.604 110.087V108.144C103.593 107.855 106.402 107.656 107.562 107.656V110.57C107.861 110.732 108.289 110.895 108.882 110.895C109.475 110.895 109.908 110.732 110.207 110.57V109.436C110.207 107.977 109.877 107.621 108.882 106.843L104.918 103.767C103.098 102.343 102.604 101.011 102.604 99.2319V97.127C102.604 93.6952 105.382 91.9463 108.882 91.9463C112.382 91.9463 115.16 93.6952 115.16 97.127V99.0692H115.165Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.592 114.942V108.464L118.963 92.2715H124.087L125.973 101.016H126.169L128.051 92.2715H133.174L128.545 108.464V114.942H123.587H123.592Z",
			fill: "#283052"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_3219_41)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M114.873 22.6592H101.821H34.8418L34.847 49.3916H114.873V22.6592Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M92.3571 30.7125L97.0581 28.1246C95.7024 26.0503 94.2179 24.2403 92.6715 22.6592H85.5478C86.687 23.8845 87.8107 25.2063 88.8725 26.635L83.8777 29.3804C89.8829 35.9339 93.9705 43.011 96.7488 49.3865H101.13C99.6251 43.616 96.9602 37.149 92.3519 30.7074L92.3571 30.7125ZM79.5117 32.1665L81.7282 42.5178L87.9756 44.6379L88.7695 43.6313C88.7695 43.6313 85.4808 37.5049 79.5117 32.1665Z",
					fill: "#283052"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.542 26.7324H48.5781V45.3251H55.8462C55.9802 44.7913 56.1142 43.0678 56.1142 42.5339H51.5369V26.7324H51.542Z",
					fill: "#283052"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.2878 26.7324H59.9785V45.3251H62.9424V29.5236H64.2878C64.829 29.5236 65.3651 29.6558 65.6332 29.788V37.0939C65.2311 37.6227 64.2878 38.1565 63.4785 38.4209V40.0122H64.2878C66.3342 40.0122 68.5971 39.1072 68.5971 36.8244V29.9202C68.5971 27.6374 66.3342 26.7324 64.2878 26.7324Z",
					fill: "#283052"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M114.873 49.4014H34.8418V71.9953H114.873V49.4014Z",
					fill: "#BF001A"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_3219_41",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 34,
					y: 49,
					width: 81,
					height: 24,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M114.873 49.3916H34.8418V72.0008H114.873V49.3916Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask0_3219_41)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M41.4501 52.5078H48.2387C50.9346 52.5078 52.7594 54.0127 52.7594 56.0871C52.7594 57.9478 51.4965 59.5697 49.5996 60.4035C50.9604 61.0492 51.8573 62.3609 51.8573 63.8607C51.8573 66.962 48.7954 68.894 45.3676 68.894H37.9707L41.4449 52.5078H41.4501ZM45.1047 65.4368C46.6357 65.4368 47.8006 64.5064 47.8006 63.2404C47.8006 62.5236 47.2181 62.1423 46.0532 62.1423H43.5429L42.8367 65.4317H45.1047V65.4368ZM45.8573 58.9952C47.2903 58.9952 48.3831 58.1105 48.3831 56.9412C48.3573 56.2955 47.8264 55.965 46.7542 55.965H44.847L44.213 58.9952H45.8521H45.8573Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M75.166 63.6726C75.166 59.6155 79.2227 56.2803 83.331 56.2803C85.5423 56.2803 87.1454 57.2819 88.1196 58.5936L85.1042 60.5713C84.7176 59.9764 83.8155 59.6409 83.0887 59.6409C81.0011 59.6409 79.0578 61.644 79.0578 63.576C79.0578 64.842 80.032 65.8181 81.3155 65.8181C82.3103 65.8181 83.4289 65.269 84.1351 64.603L86.5423 67.0383C84.9856 68.4466 83.1402 69.1838 81.0268 69.1838C77.6712 69.1838 75.1712 66.7282 75.1712 63.6726",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M98.791 63.6726C98.791 59.6155 102.848 56.2803 106.956 56.2803C109.167 56.2803 110.77 57.2819 111.745 58.5936L108.729 60.5713C108.343 59.9764 107.441 59.6409 106.714 59.6409C104.626 59.6409 102.683 61.644 102.683 63.576C102.683 64.842 103.657 65.8181 104.941 65.8181C105.935 65.8181 107.054 65.269 107.76 64.603L110.167 67.0383C108.611 68.4466 106.765 69.1838 104.652 69.1838C101.296 69.1838 98.7962 66.7282 98.7962 63.6726",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M58.6983 65.8183C58.1004 65.8183 57.5746 65.62 57.1674 65.2947L62.5901 62.9153L66.5591 61.1714C66.4663 60.3376 66.1828 59.5547 65.7395 58.8734C64.7292 57.3176 62.8993 56.2754 60.688 56.2754C56.6055 56.2754 52.5488 59.5903 52.5488 63.6677C52.5488 63.9931 52.5798 64.3134 52.6365 64.6236C52.7808 65.4472 53.1158 66.2047 53.6004 66.8555C54.6416 68.2638 56.3839 69.1739 58.456 69.1739C60.5282 69.1739 62.4251 68.3757 63.9354 67.0843L61.4715 64.5931C60.7138 65.3201 59.7138 65.8082 58.6983 65.8082M60.4715 59.6411C61.2086 59.6411 61.8272 59.936 62.2447 60.4088L56.4303 62.961C56.7859 61.2273 58.5798 59.6411 60.4715 59.6411Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M74.4036 51.7912L70.0582 53.6978L69.4448 56.5601H67.7902L67.084 59.7784H68.7592C67.6665 64.7863 67.5427 65.31 67.5427 65.9302C67.5427 67.8164 68.9036 69.1739 70.9706 69.1739C72.0891 69.1739 73.3056 68.7672 74.1562 68.1012L73.718 65.2845C73.45 65.5235 72.8675 65.8082 72.3108 65.8082C71.8726 65.8082 71.6304 65.5947 71.6304 65.071C71.6304 64.7863 71.7025 64.4965 72.6974 59.7733H75.2953L75.9757 56.5551H73.3778L74.4036 51.7861V51.7912Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M90.46 52.5078H94.3621L90.9033 68.894H86.9961L90.46 52.5078Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M95.1511 56.5649H99.0737L96.45 68.899H92.5273L95.1511 56.5649ZM95.7232 53.3924C95.7232 52.1061 96.8882 51.0791 98.1047 51.0791C99.2232 51.0791 100.048 51.9637 100.048 53.0365C100.048 54.2516 98.9294 55.3244 97.7387 55.3244C96.548 55.3244 95.7232 54.4651 95.7232 53.3924Z",
							fill: "white"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern0_3219_41",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image0_3219_41",
					transform: "scale(0.00342466 0.010989)"
				})
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_3219_41",
				x: 28.5818,
				y: 16.3992,
				width: 92.5513,
				height: 61.8559,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.13 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_3219_41"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_3219_41",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image0_3219_41",
				width: 292,
				height: 91,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASQAAABbCAYAAADa+vhMAAAACXBIWXMAAAsSAAALEgHS3X78AAAFN0lEQVR4nO3cbW/aSBSG4YeXJCzbbtWV+v//Yas0gQRD4v0wczLHg21IN7s66tyXNOIl4PbTrTM2IAEAAGBo8T+9B0Cb+ve8+Jq4LCZu33MMAG2oA9RP3I6ai8nC/X3pHl8KFIB2jQXI1mv13Jn1xEF9fJaSVvnWL4IEoOZD9FqtF5Uo+de+GQtSHaJVfp1fPkz1ewG0pQ6Lj9CpWi8ahmnw3rkgWYhu87pz929UpqZF9V4Abemr+zYNHSV1eR3cff+e2SD5c0YrpfhsJG3d2ijFaS2iBLRuKkYnpQg9S9q7Vb9u4Y8xNiFZjGw62kr6LOmvvP7Mz91quH0D0Da/TeuUArST9FOpKfYa27L1+f6bsQnJzh+tlSahrVKI/s7ri6RPSpOS37rZ+wG0xSYcv1V7lvQo6V6lM/a3o1K0rDezE5IPkk1IFqRvKlHyU5L/OACA9tilfD8d3Ss1QipbuCeVndVZM3yQ6kv9FqSN0jbti0qUvubnNnMHB9AMOy90UpqOdiox6vLjBw1P9fjm9NL055DsvNCNyrbtk1KUviqF6bPKto0gAW2zINl27S4/3ylt3bb5OevF6Hnnaz6H5CelrdJkZCe5/1C52mbvBdAWOwdkV9dsMjqoXJm3ychfmZ/dstWsYhalG5UwbZRi5E9sEyOgXXbF7JgfdyohutEwRpNX5aeusvmvhdRhsjjZLUEC0KuE5qTSiDpEvi1nU9LchGR8lOpA2ZocwQD89vyXZV91HqA6RpOuCZI3NkHVC0Cbptpwtbkg1Qeb+x0kYgS069JvpF3dimu+8kFoAHyEiy3hO2gAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMIgSADCIEgAwiBIAMK4Jkj9f/6/ANCCiy2ZC1JfHaA+WP03wgW06cNasf7Ff7ifeAygPb0+qA3XBKmX9JqXv/+Sl01Zi/f8wwB+K71KE1403oyLcaqDNFY5H6BTXkd3q/x3ggS0y4Lk22C9qANlrz+boOYmpDpER0mdpOe8bvPrTpJW+T5RAtpjUbFWPKl0olOJkw/TqLEgWbV8jCxEe0k7SXf5tZ2kG6VtGzEC2mXNOCq14kGpFXuVMPkojZ5fmpqQrGJHSYd80EdJ9yqT0UHSJh+DIAFtsyCdlAK0k/RDqRmPSg05KDVlckryQfJ7OjuwTUY7DWPUSdrmx2ulGBEkoF3WDuvGXqkZ3/PtTsNJyU9Jb5PS1JbNB2kv6ad7badUvI3Sdm0lrrQBLbOg2Gke27bZruq7UkP2Og/SwNRVNguSbdfspPVJqXR+OlqKr6AAKFsxP8zslGJkQTrofEJ6MzYh1Sez9/n5l3ywB6WT2muV6chPRkxJQDvqT2H7fhxULobZqk9uD4xNSAt30C4/bye4n5QmI79VI0ZA26aiZB8V6pTiZPd9jC5OSP4zBfbYDr7WcJtWb9UIEtCe+lzQq4bbN7/sk9yjl/2nArJwa6kyDfm1cK8FAGn8Wx7+Q9ajV9fMXEz8pfylhpHSyC0A9CO3/mKZf+7MNTG5FCCCBMBM/fRIfTvqV2JCgABci58mAgAA+Ff+Aakbm9yvxhyvAAAAAElFTkSuQmCC"
			})
		] })
	]
});
export default SvgClientLogo;
